import * as yup from 'yup';

import { MenuPhotoShootOption, menuPhotoShootOptions } from '../../SelfServeFormView/SelfServeSignUpForm/types';

export const BusinessDetailsValidationSchema = yup.object({
  name: yup.string().trim().required(),
  address: yup.string().trim().required(),
  postCode: yup.string().trim().required(),
  city: yup.string().trim().required(),
  businessName: yup.string().trim().required(),
  businessId: yup.string().trim().required(),
  isSameAddress: yup.boolean(),
  businessAddress: yup
    .string()
    .trim()
    .when('isSameAddress', (isSameAddress: boolean, schema: yup.StringSchema) =>
      !isSameAddress ? schema.required().nullable() : schema,
    )
    .defined(),
  businessPostCode: yup
    .string()
    .trim()
    .when('isSameAddress', (isSameAddress: boolean, schema: yup.StringSchema) =>
      !isSameAddress ? schema.required().nullable() : schema,
    )
    .defined(),
  businessCity: yup
    .string()
    .trim()
    .when('isSameAddress', (isSameAddress: boolean, schema: yup.StringSchema) =>
      !isSameAddress ? schema.required().nullable() : schema,
    )
    .defined(),
  businessOtherCity: yup
    .string()
    .trim()
    .when('city', (city: string, schema: yup.StringSchema) => (city === 'other' ? schema.required() : schema))
    .nullable(),
});

const WeeklyScheduleTimePairs = yup
  .array()
  .of(yup.object({ startMinutes: yup.number().required(), endMinutes: yup.number().required() }))
  .required();

export const OpeningHoursValidationSchema = yup.object({
  openingHours: yup.object({
    monday: WeeklyScheduleTimePairs,
    tuesday: WeeklyScheduleTimePairs,
    wednesday: WeeklyScheduleTimePairs,
    thursday: WeeklyScheduleTimePairs,
    friday: WeeklyScheduleTimePairs,
    saturday: WeeklyScheduleTimePairs,
    sunday: WeeklyScheduleTimePairs,
  }),
});

export const productListValidationSchema = yup.object({
  source: yup.string().trim().required().oneOf(['link', 'file'], 'source must be either link or file'),
  link: yup.string().trim().url().when('source', {
    is: 'link',
    then: yup.string().required(),
    otherwise: yup.string().notRequired(),
  }),
});

export const CommissionsPreferencesSchema = yup.object({
  joinedToWoltPlus: yup.boolean().required(),
});

export const DevicePreferencesSchema = yup.object({
  needsPrinter: yup.boolean().required(),
  needsMobileDataPackage: yup.boolean().required(),
});

export const MenuPhotoShootOptionPreferencesSchema = yup.object({
  menuPhotoShootChoice: yup
    .string()
    .oneOf<MenuPhotoShootOption>([...menuPhotoShootOptions])
    .required(),
});

export type BusinessDetails = yup.InferType<typeof BusinessDetailsValidationSchema>;
export type OpeningHours = yup.InferType<typeof OpeningHoursValidationSchema>;
export type ProductList = yup.InferType<typeof productListValidationSchema>;
export type CommissionsPreferences = yup.InferType<typeof CommissionsPreferencesSchema>;
export type DevicePreferences = yup.InferType<typeof DevicePreferencesSchema>;
export type MenuPhotoShootOptionPreferences = yup.InferType<typeof MenuPhotoShootOptionPreferencesSchema>;
